import { Routes } from "@angular/router";
import { RecentOpportunitiesComponent } from "./components/admin/recent-opportunities/recent-opportunities.component";
import { AvailableReferralsComponent } from "./components/admin/available-referrals/available-referrals.component";
import { PurchasedReferralsComponent } from "./components/admin/purchased-referrals/purchased-referrals.component";
import { DashboardComponent } from "./components/dashboard/dashboard.component";
import { AllReferralsComponent } from "./components/admin/all-referrals/all-referrals.component";
import { AuthGuard } from "./auth/auth.guard";
import { AdminComponent } from "./components/admin/admin.component";
import { PublicComponent } from "./components/public/public.component";
import { MarketplacesComponent } from "./components/admin/marketplaces/marketplaces.component";
import { MarketplaceComponent } from "./components/admin/marketplace/marketplace.component";
import { CanDeactivateGuard } from "./guards/unsaved-changes.guard";
import { FeatureFlagsComponent } from "./components/admin/feature-flags/feature-flags.component";
import { MailgunSuppressionComponent } from "./components/admin/mailgun-suppression/mailgun-suppression.component";
import { ConsumerSmsCampaignComponent } from "./components/admin/consumer-sms-campaign/consumer-sms-campaign.component";
import { ConsumerEmailCampaignComponent } from "./components/admin/consumer-email-campaign/consumer-email-campaign.component";
import { StateAssociationsComponent } from "./components/admin/state-associations/state.associations.component";
import { StateAssociationComponent } from "./components/admin/state-association/state.association.component";
import { RoleEnum } from "./models/role.enum";

export const routes: Routes = [
  {
    path: "admin",
    component: AdminComponent,
    children: [
      {
        path: "all-referrals",
        component: AllReferralsComponent,
        canActivate: [AuthGuard],
        data: {
          sortField: "addDate",
          sortOrder: "desc",
          showClaimed: true,
          showExpiration: true
        }
      },
      {
        path: "claim-it-referrals",
        component: AvailableReferralsComponent,
        canActivate: [AuthGuard]
      },
      { path: "dashboard", component: DashboardComponent, canActivate: [AuthGuard] },
      {
        path: "consumer-sms-campaign",
        component: ConsumerSmsCampaignComponent,
        canActivate: [AuthGuard],
        data: { requiredRoles: [RoleEnum.ROLE_CONSOLE_ADMIN] }
      },
      {
        path: "consumer-email-campaign",
        component: ConsumerEmailCampaignComponent,
        canActivate: [AuthGuard],
        data: { requiredRoles: [RoleEnum.ROLE_CONSOLE_ADMIN] }
      },
      {
        path: "feature-flags",
        component: FeatureFlagsComponent,
        canActivate: [AuthGuard],
        data: { requiredRoles: [RoleEnum.ROLE_CONSOLE_ADMIN] }
      },
      {
        path: "mailgun-suppression",
        component: MailgunSuppressionComponent,
        canActivate: [AuthGuard],
        data: { requiredRoles: [RoleEnum.ROLE_CONSOLE_ADMIN] }
      },
      {
        path: "marketplaces",
        component: MarketplacesComponent,
        canActivate: [AuthGuard],
        canDeactivate: [CanDeactivateGuard]
      },
      {
        path: "marketplaces/:marketplaceId",
        component: MarketplaceComponent,
        canActivate: [AuthGuard],
        canDeactivate: [CanDeactivateGuard]
      },
      {
        path: "purchased-referrals",
        component: PurchasedReferralsComponent,
        canActivate: [AuthGuard]
      },
      {
        path: "recent-opportunities",
        component: RecentOpportunitiesComponent,
        canActivate: [AuthGuard]
      },
      {
        path: "state-associations",
        component: StateAssociationsComponent,
        canActivate: [AuthGuard]
      },
      {
        path: "state-associations/:id",
        component: StateAssociationComponent,
        canActivate: [AuthGuard]
      },

      { path: "**", redirectTo: "all-referrals" }
    ],
    canActivate: [AuthGuard]
  },
  {
    path: "public-referrals",
    component: PublicComponent
  },
  { path: "**", redirectTo: "public-referrals" }
];
